import { Action } from 'redux';
import * as _ from 'underscore';

import { ServerFilterClauses } from '../../../ts/helpers/ServerFilterClauses';
import { IStringValuedFilterClause } from '../../../ts/ServerApi/types/IFilterClause';
import { isClearFilterContentAction } from '../../actions/spaces/ContentExplorerFilterActions';
import { isFilterContentAction } from '../../actions/spaces/filters/FilterActions';
import { cloneFilterMap, doesActionCreateSameFilter } from '../../actions/spaces/filters/FilterHelpers';
import { FilterMap } from '../../state/ContentExplorerState';

export function mixedContentFilterReducer(
  previousState: FilterMap = {},
  action: Action = null
): FilterMap {
  if (isFilterContentAction(action)) {
    const newState = cloneFilterMap(previousState);
    const filter = newState[action.filterType] as IStringValuedFilterClause;

    if (!_.isUndefined(filter) && doesActionCreateSameFilter(filter, action)) {
      return previousState;
    } else if (!_.isUndefined(filter) && action.value === undefined) {  // user cleared filter
      delete newState[action.filterType];
    } else if (action.value === undefined) {  // user cleared filter but it wasn't in the store for some reason
      return previousState;
    } else {
      newState[action.filterType] =
        ServerFilterClauses.serverFilterClauses[action.filterType](action.value);
    }
    return newState;
  } else if (isClearFilterContentAction(action)) {
    return {};
  }

  return previousState;
}
